import React from "react"
import styled from 'styled-components'
import get from 'lodash/get'
import { Label } from 'reactstrap'

import { FONTS } from '../../../../constants'
import { Button } from '../../../buttons'

export default class Searchbar extends React.Component {
  render() {
    const editOtherCost = get(this.props, 'editOtherCost')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    // const canEdit = get(projectByID, '$can_edit')
    const total_other_costs_sum = isPresale ? get(presale_snapshot, '$total_other_costs_sum', '-') : get(projectByID, '$total_other_costs_sum', -1)
    // const clickEdit = get(this.props, 'clickEdit')
    // const cancelEdit = get(this.props, 'cancelEdit')
    // const confirmEditOtherCost = get(this.props, 'confirmEditOtherCost')
    const clickAddOtherCost = get(this.props, 'clickAddOtherCost')
    return (
      <SearchDivStyle >
        <SetForm>
          <SearchEmployeeDiv style={ { display: 'flex', flexDirection: 'row' } }>
            {/* <SearchField
              onChange={ this.props.handleSearch }
              onKeyDown={ this.props.handleSearch }
              placeholder={ 'Search By Cost Type' }
            /> */}
            {
              !isPresale &&
              <ButtonGroup>
                {/* { !editOtherCost && canEdit &&
                  <LastRightButton color='success' onClick={ () => clickEdit() }>Edit</LastRightButton>
                }
                { editOtherCost &&
                  <RightButton color='success' onClick={ () => confirmEditOtherCost() }>Save</RightButton>
                }
                { editOtherCost &&
                  <RightButton onClick={ () => cancelEdit() }>Cancel</RightButton>
                } */}
                { editOtherCost &&
                <Button
                  theme='#D44B49'
                  width='120px'
                  height='26px'
                  onClick={ () => clickAddOtherCost() }
                >
                  Add Other Cost
                </Button>
                  // <LastRightButton color='danger' onClick={ () => clickAddOtherCost() }>Add Other Cost</LastRightButton>
                }
              </ButtonGroup>
            }
          </SearchEmployeeDiv>
          <div style={ { display: 'flex', flexDirection: 'row', flexFlow: 'column' } }>
            <Header>
              <TextHeader>Total Cost (฿)</TextHeader>
              <TextNumber>{ total_other_costs_sum }</TextNumber>
            </Header>
          </div>
        </SetForm>
      </SearchDivStyle>

    )
  }
}
const SearchDivStyle = styled.div`
  background-color: #ffffff ;
  margin-top: 10px;
  width: 100%;
`
const SetForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 16px;
`
const SearchEmployeeDiv = styled.div`
  height: 40px;
  padding: auto;
`
const Header = styled.div`
  height: 30px;
  background: #404040;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`
const TextHeader = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin:auto;
  margin-left: 5% !important;
  margin-right: 5px !important;
`
const TextNumber = styled.p`
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin:auto;
  float:left;
  margin-left: 10px !important;
`



// WEBPACK FOOTER //
// ./src/components/project-information/searchbar/searchbar-other-cost/index.js